import { ClientBranding } from '@/types/client'

import { apiClient } from '../axios'

/**
 * Fetch a client's public name and display theme.
 *
 * Uses `apiClient` directly rather than `requestWithRetry`: the endpoint is
 * unauthenticated and this runs on the sign-in screen, where the retry helper's
 * 401 -> refresh -> redirect-to-/login path would be exactly the wrong response.
 */
export const getClientBranding = async (
  clientUid: string,
): Promise<ClientBranding> => {
  const { data } = await apiClient.get<ClientBranding>(
    `events/public/client/${clientUid}/branding`,
  )
  return data
}
